import sharedStoreConfig from "../../public/store.config.json";

export const STORE_CONFIG = Object.freeze({
  ...sharedStoreConfig,
  paymentMethods: Object.freeze([...sharedStoreConfig.paymentMethods]),
  paymentRestrictedCountryCodes: Object.freeze([...sharedStoreConfig.paymentRestrictedCountryCodes]),
  paymentRestrictedRegions: Object.freeze(sharedStoreConfig.paymentRestrictedRegions.map((entry) => Object.freeze({
    ...entry,
    names: Object.freeze([...entry.names]),
  }))),
});

export const PAYMENT_RESTRICTED_COUNTRY_CODES = STORE_CONFIG.paymentRestrictedCountryCodes;

export const formatMoney = (value) =>
  new Intl.NumberFormat(STORE_CONFIG.locale, {
    style: "currency",
    currency: STORE_CONFIG.currency,
    minimumFractionDigits: 2,
  }).format(Number(value));

export const storeText = (value) =>
  String(value)
    .replace(/\{\{brand\}\}/g, STORE_CONFIG.brand)
    .replace(/\{\{email\}\}/g, STORE_CONFIG.supportEmail)
    .replace(/\{\{region\}\}/g, STORE_CONFIG.operatingRegion)
    .replace(/\{\{currency\}\}/g, STORE_CONFIG.currency)
    .replace(/\{\{timezone\}\}/g, STORE_CONFIG.timezone)
    .replace(/\{\{shipping\}\}/g, `${STORE_CONFIG.shippingFee.toFixed(2)} ${STORE_CONFIG.currency}`);
